import { useEffect, useState } from 'react';
import { ContractService } from '../../../services/contract/contractService';

/*----------------------------------------------------------------------------------------
* EN: Hook to manage client Student history fetching and transformation logic.
* ES: Hook para gestionar la lógica de obtención y transformación del historial de asesorias de clientes.
----------------------------------------------------------------------------------------*/

const useClientStudentsHistory = (initialFilters = {}, limit = 99999) => {

    const [data, setData] = useState<any[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [isMoreResults, setIsMoreResults] = useState<boolean>(false);
    const [filters, setFilters] = useState<Record<string, any>>({
        limit: limit,
        filter_filters: { ...initialFilters }
    });

    const fetchData = async () => {
        try {
            setIsLoading(true);
            const service = new ContractService();
            const response = await service.showClientStudentsHistory(filters);
            const fetchedData = response.getResponseData()?.data;

            setIsMoreResults(fetchedData?.data?.length >= filters.limit);

            if (fetchedData && fetchedData?.data) {
                const mappedData = fetchedData?.data?.map((data: any) => ({
                    id: data.id,
                    fullName: data.name + ' ' + data.firstName + ' ' + data.lastName,
                    nif: data.nif,
                    email: data.email,
                    tfno: data.telephone,
                    studentStudyId: data.study?.id,
                    studentQuotationGroupId: data.quotationGroup?.id,
                    studentProfessionalCategoryId: data.professionalCategory?.id,
                    name: data.name,
                    firstName: data.firstName,
                    lastName: data.lastName,
                    gender: data.gender,
                    terrorismVictim: data.terrorismVictim,
                    genderViolenceVictim: data.genderViolenceVictim,
                    disability: data.disability,
                    socialSecurityNumber: data.socialSecurityNumber,
                    functionalArea: data.functionalArea,
                    telephone: data.telephone,
                    telephoneSecondary: data.telephoneSecondary,
                    alternativeShippingAddress: data.alternativeShippingAddress,
                    contactSchedule: data.contactSchedule,
                    birthDate: data.birthDate

                }));
                setData(mappedData);
            }
        } catch (error) {
            console.log('Error fetching client consultancies history:', error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, [filters]);

    const getList = (entityId?: string) => {
        if (entityId) return data.filter((state: any) => state.id === entityId);
        return data;
    };

    const addFilter = (key: string, value: any) => {
        setFilters(prevFilters => ({
            ...prevFilters,
            filter_filters: {
                ...prevFilters.filter_filters,
                [key]: value
            }
        }));
    };

    const modifyLimit = (amount = 5) => {
        if (filters.limit + amount >= 5) {
            setFilters(prevFilters => ({
                ...prevFilters,
                limit: prevFilters.limit + amount
            }));
        }
    }

    const updateClientId = (value: string) => {
        setFilters(prevFilters => ({
            ...prevFilters,
            filter_filters: {
                ...prevFilters.filter_filters,
                client: value
            }
        }));
    }

    const getEntity = (id: string) => {
        return data.find((entity: any) => entity.id === id);
    }

    return { fetchClientStudentHistory: fetchData, getClientStudentsList: getList, modifyLimitClientStudent: modifyLimit, addClientStudentFilter: addFilter, getClientStudent: getEntity, updateClientId, isMoreClientStudents: isMoreResults, isLoadingClientStudents: isLoading };
}

export default useClientStudentsHistory;